import * as cookies from 'lib/cookies';

import { DEFAULT_LOCALE } from './translations';
import { LOCALES, type Locale } from './types';

function getLangParamValue(value: string | Array<string> | undefined) {
  return Array.isArray(value) ? value[0] : value;
}

export function getLocaleFromLangParam(value: string | Array<string> | undefined): Locale | undefined {
  switch (getLangParamValue(value)?.toLowerCase()) {
    case 'en':
    case 'en-us':
      return 'en';

    case 'zh':
    case 'zh-cn':
      return 'zh-CN';

    case 'zh-tw':
    case 'zh-hk':
      return 'zh-TW';

    default:
      return undefined;
  }
}

export function getStoredLocale(serverCookie?: string): Locale | undefined {
  const storedLocale = cookies.get(cookies.NAMES.LOCALE, serverCookie);

  if (storedLocale && (LOCALES as ReadonlyArray<string>).includes(storedLocale)) {
    return storedLocale as Locale;
  }

  return undefined;
}

export function resolveLocale(
  langParam: string | Array<string> | undefined,
  serverCookie?: string,
): Locale {
  return getLocaleFromLangParam(langParam) ?? getStoredLocale(serverCookie) ?? DEFAULT_LOCALE;
}
